import ProfileItemForm from "./ProfileItemForm";
import React from "react";
import ProfileCertificationRow from "../../profiles/components/ProfileCertificationRow";
import { FormInputComponent } from "../../../components/form/Form";
import { TalentAppCard } from "./TalentAppCard";
import { Input } from "antd";
import dateformat from "dateformat";

export default class CertificationForm extends ProfileItemForm {

    static ItemType = 'Certification'

    static FormClass = 'talent-role-form add-talent-form add-cert-form '

    static shouldUseTalentAppCard = true;
    static ShowProfilePreview = true;

    static TypeConfig = {
        icon: 'fas fa-award',
        color: TB.config('color.light_purple')
    }

    getModelFromProps() {
        let model = { ...(this.props.model || {}) };

        if (model.earned_at) {
            if (typeof model.earned_at === 'string') {
                model.earned_at = new Date(model.earned_at)
            }
            model.earned_at_year = model.earned_at.getFullYear();
            model.earned_at_month = model.earned_at.getMonth() + 1;
        }

        return model;
    }

    async onChange(model) {
        await super.onChange({
            ...model,
            ...this.setDateFromInputs(model, 'earned_at')
        });

        let errors = {
            ...this.validateDateBeforeToday('earned_at', 'Earned date')
        };

        if (Object.keys(errors).length) {
            this.formRef.current.updateInputsWithError(errors)
        }
    }

    /**
     * The fields mapping for the form
     */
    // formFields_LEGACY = () => {


    //     // 'certifications.*.name'           => 'required|string|max:255',
    //     // 'certifications.*.image_path'     => 'nullable|string|max:255', OR 'nullable|image',
    //     // 'certifications.*.earned_at'      => 'required|string|max:255',
    //     // 'certifications.*.expires_at'     => 'nullable|string|max:255',
    //     // 'certifications.*.description'    => 'nullable|string|max:255',

    //     return [
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 name: {
    //                     type: 'text',
    //                     label: TB.trans('talent.certification_form.certification_name_label'),
    //                     required: true,
    //                     maxLength: 255,
    //                     placeholder: TB.trans('talent.certification_form.certification_name_placeholder'),
    //                     style: styles.field,
    //                     columns: 10
    //                 }
    //             }
    //         },

    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 earned_at: {
    //                     type: 'hidden-date',
    //                     label: TB.trans('talent.certification_form.earned_date_label'),
    //                     required: true,
    //                     style: styles.field,
    //                     className: 'field hide-input',
    //                     columns: 10
    //                 }
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             className: 'field-section field-section-select',
    //             fields: {
    //                 earned_at_month: {
    //                     label: false,
    //                     placeholder: 'Month',
    //                     type: 'select',
    //                     required: false,
    //                     options: this.monthOptions(),
    //                     labelClassName: 'hide-label',
    //                     className: 'field hide-label',
    //                     style: { ...styles.field, maxWidth: 110, paddingRight: 0 },
    //                 },
    //                 earned_at_year: {
    //                     label: false,
    //                     placeholder: 'Year',
    //                     type: 'select',
    //                     required: false,
    //                     labelClassName: 'hide-label',
    //                     options: this.yearOptions(),
    //                     style: { ...styles.field, maxWidth: 110 },
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 image_path: {
    //                     label: TB.trans('talent.certification_form.certification_logo_label'),
    //                     type: 'pixie',
    //                     width: 150,
    //                     height: 150,
    //                     maxWidth: 300,
    //                     ratio: '1:1',
    //                     circular: false,
    //                     required: false,
    //                     style: styles.field,
    //                     columns: 8
    //                 },
    //             }
    //         },
    //         {
    //             style: styles.fieldSection,
    //             fields: {
    //                 description: {
    //                     label: TB.trans('talent.certification_form.certification_summary_label'),
    //                     placeholder: TB.trans('talent.certification_form.certification_summary_placeholder'),
    //                     type: 'textarea',
    //                     required: false,
    //                     style: styles.field,
    //                     maxLength: 10000,
    //                     columns: 10,
    //                     rows: 10
    //                 },
    //             }
    //         },
    //     ]
    // };


    renderTitle() {
        return null;
    }

    renderFormFields() {
        const { isEditing } = this.props;

        if (isEditing) {
            return (
                <TalentAppCard.Section>
                    {this.renderFormData()}
                </TalentAppCard.Section>
            )
        }

        return (
            <TalentAppCard.Section>
                {this.renderFormattedData()}
            </TalentAppCard.Section>
        )
    }

    renderFormData = () => {
        const { disabled, isEditing } = this.props;
        const isDisabled = disabled || !isEditing;
        const monthOptions = this.monthOptions();
        const yearOptions = this.yearOptions();

        return (
            <div>
                <div className="wfull field">

                    <FormInputComponent
                        type="antd-input"
                        fieldName="name"
                        label={TB.trans('talent.certification_form.certification_name_label')}
                        maxLength={255}
                        required
                        value={this.state.model.name}
                    >
                        <Input
                            placeholder={TB.trans('talent.certification_form.certification_name_placeholder')}
                            disabled={isDisabled}
                            className="input-default"
                        />
                    </FormInputComponent>
                </div>

                <div className="flex flex-col gap-4 field-section field-section-select">

                    <div>
                        {/* <label className="col-form-label">{TB.trans('talent.certification_form.earned_date_label')}</label>
                        <div className="hide-input [&_.invalid-feedback]:!block [&_.invalid-feedback]:!relative [&_.invalid-feedback]:!mt-1">
                            <FormInputComponent
                                type="hidden-date"
                                fieldName="earned_at"
                                label={false}
                                required={true}
                                value={this.state.model.earned_at}
                            />
                        </div> */}

                        <div className="field hide-input">
                            <FormInputComponent
                                type="hidden-date"
                                fieldName="earned_at"
                                label={TB.trans('talent.certification_form.earned_date_label')}
                                required
                                maxDate={new Date()}
                                value={this.state.model.earned_at}
                            />
                        </div>

                        <div className="flex flex-row gap-2 form-group field select-field">
                            <div className="w-full max-w-[130px]">
                                <FormInputComponent
                                    fieldName="earned_at_month"
                                    type="select"
                                    label={false}
                                    placeholder="Month"
                                    required={false}
                                    options={monthOptions}
                                    labelClassName="hide-label"
                                    className="field hide-label"
                                    value={this.state.model.earned_at_month}
                                />
                            </div>
                            <div className="w-full max-w-[130px]">
                                <FormInputComponent
                                    fieldName="earned_at_year"
                                    type="select"
                                    label={false}
                                    placeholder="Year"
                                    required={false}
                                    options={yearOptions}
                                    labelClassName="hide-label"
                                    value={this.state.model.earned_at_year}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                <div className="field">

                    <FormInputComponent
                        fieldName="image_path"
                        label={TB.trans('talent.certification_form.certification_logo_label')}
                        type="pixie"
                        width={150}
                        height={150}
                        maxWidth={300}
                        ratio="1:1"
                        circular={false}
                        required={false}
                        value={this.state.model.image_path}
                    />
                </div>
                <div className="field">

                    <FormInputComponent
                        fieldName="description"
                        label={TB.trans('talent.certification_form.certification_summary_label')}
                        type="antd-input"
                        required={false}
                        maxLength={10000}
                        value={this.state.model.description}
                    >
                        <Input.TextArea
                            placeholder={TB.trans('talent.certification_form.certification_summary_placeholder')}
                            disabled={isDisabled}
                            className="input-default"
                            rows={6}
                            maxLength={10000}
                        />
                    </FormInputComponent>
                </div>
            </div>
        )
    }

    renderFormattedData() {
        const { name, earned_at, image_path, description } = this.state.model;

        const formatDate = (date) => {
            if (!date) return null;
            if (typeof date === 'string') date = new Date(date);
            return dateformat(date, 'mmm yyyy');
        };

        const earnedDate = formatDate(earned_at);

        return (
            <div className="flex flex-col sm:flex-row items-start gap-4">
                {image_path && (
                    <div className="shrink-0">
                        <img
                            src={image_path}
                            alt={`${name} logo`}
                            className="h-[48px] w-[48px] rounded object-contain"
                        />
                    </div>
                )}
                <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold m-0 truncate">{name || '—'}</p>
                    {earnedDate && (
                        <p className="text-xs text-gray-500 mt-1 m-0">Earned {earnedDate}</p>
                    )}
                    {description && (
                        <p className="text-xs text-gray-600 mt-2 m-0 line-clamp-2">{description}</p>
                    )}
                </div>
            </div>
        )
    }

    renderFormFooterInfo() {
        return <div />
    }

    renderEditFormButton() {
        return (
            <button
                className="btn btn-primary px-6"
                disabled={this.props.disabled}
                type="button" onClick={() => this.props.onEditing(true)}
            >
                Edit Certification
            </button>
        );
    }

    renderProfilePreview() {
        return (
            <TalentAppCard.Section>
                <ProfileCertificationRow certification={this.getModelFromProps()} />
            </TalentAppCard.Section>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};